<template>

    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Histórico gestante"
        :buttons="['cancel']"
    >

        <rkm-table
            :fields="fields"
            :items="items"
        />
    </rkm-modal>
</template>

<script>

export default {
    computed: {
        fields() {
            return [
                { key: 'data', label: 'Data do atendimento', class: 'col-min', sortable: true },
                { key: 'unidade', label: 'Unidade', sortable: true },
                { key: 'usuario', label: 'Profissional', sortable: true },
                { key: 'ocupacao', label: 'CBO', sortable: true },
                { key: 'dum', label: 'DUM', sortable: true },
                { key: 'idadeGestacional', label: 'Idade gestacional', sortable: true },
            ]
        },
    },
    data: () => ({
        exame: null,
        index: null,
        solicitado: false,
        avaliado: false,
    }),
    methods: {
        open(index, item) {

            if (!(index === undefined || index === null)) {
                this.index = index
            }

            if (item) {

                this.exame = {
                    id: item.exameId,
                    codigo: item.codigo,
                    nome: item.exameNome
                }

                this.avaliado = item.avaliado
                this.solicitado = item.solicitado
            }

            this.$refs.RkmModal.show()
        },
    },
    props: {
        items: { type: Array, required: false },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>